/**
 * Global CSS overrides for react-jewish-datepicker popup to match the
 * design-system MUI DatePicker calendar style.
 *
 * Injected via <HebrewDatePickerGlobalStyles /> which is rendered once inside
 * HebrewDatePicker. Using a <style> tag keeps these scoped to the lib without
 * requiring a separate CSS file in the app.
 */
export const HEBREW_PICKER_STYLES = `
  .jewish-picker {
    margin-bottom: 0 !important;
    background: transparent !important;
  }

  /* Hide the library trigger (we render our own icon). Keep it clickable for programmatic open. */
  .jewish-picker .selectedDate {
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    margin: 0 !important;
    min-height: 20px !important;
    width: 20px !important;
    height: 20px !important;
    border-radius: 0 !important;
    font-size: 0 !important; /* hides the value text */
    opacity: 1 !important; /* keep clickable */
    position: relative;
    z-index: 0;
    pointer-events: auto !important;
  }

  .jewish-picker .calendarIcon {
    display: none !important;
  }

  /* Popup container */
  .jewish-picker .monthWrapper {
    top: 32px;
    left: auto !important;
    right: 0;
    border-radius: 12px;
    box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);
    background-color: #fff;
    width: 310px !important;
    height: auto !important;
    min-height: auto;
    padding: 0 !important;
    display: block !important;
    gap: 0 !important;
    transition: none !important;
    z-index: 1500 !important;
  }

  /* Navigation header — matches MUI calendar header */
  .jewish-picker .navigation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 4px 4px 16px;
  }

  .jewish-picker .monthYearSelection {
    justify-content: center;
    gap: 4px;
  }

  .jewish-picker .monthYearSelection select {
    border: none;
    background: transparent;
    font-size: 14px;
    font-weight: 400;
    color: inherit;
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
    appearance: none;
    -webkit-appearance: none;
  }

  .jewish-picker .monthYearSelection select:hover {
    background-color: rgba(0,0,0,0.04);
  }

  /* Arrow buttons — match MUI RTL-rotated arrow switcher */
  .jewish-picker .arrowLeft,
  .jewish-picker .arrowRight {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    background: transparent;
  }

  .jewish-picker .arrowLeft:hover,
  .jewish-picker .arrowRight:hover {
    background-color: rgba(0,0,0,0.04);
  }

  .jewish-picker .navigation .arrowLeft span,
  .jewish-picker .navigation .arrowRight span {
    border-color: rgba(0,0,0,0.56);
  }

  /* Weekday header */
  .jewish-picker .weekdayWrapper {
    background-color: #fff;
    padding: 0 4px;
  }

  .jewish-picker .weekday {
    color: rgba(0,0,0,0.38);
    font-weight: 400;
    font-size: 12px;
    width: 36px;
    height: 36px;
  }

  /* Days */
  .jewish-picker .day {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .jewish-picker .day:hover {
    background-color: rgba(0,0,0,0.04);
  }

  .jewish-picker .day.selectedDay {
    background-color: #660a23;
    color: #fff;
  }

  .jewish-picker .day.selectedDay:hover {
    background-color: #7d0e2a;
  }

  .jewish-picker .day.otherMonth {
    color: rgba(0,0,0,0.38);
  }

  /* Mobile fullscreen */
  @media (max-width: 480px) {
    .jewish-picker .monthWrapper {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      width: 100vw !important;
      height: 100vh !important;
      border-radius: 0 !important;
      z-index: 1400 !important;
      padding: 16px !important;
      box-sizing: border-box !important;
      overflow: auto !important;
    }
  }
`;
